import * as React from 'react';

export default function JobTags({ blok }) {
  if (!blok.job_tags) {
    return null;
  }
  const tags = blok.job_tags.split(',');

  return (
    <div
      className="flex gap-4 mb-8 text-white"
      key={`job-tags-${blok._uid}`}
    >
      {tags.map((tag) => (
        <div key={tag} className="bg-green-900 p-2 text-xs lg:text-base">
          {tag.trim()}
        </div>
      ))}

    </div>
  );
}
